import React, { useState, useEffect } from 'react'
import { navigate } from 'gatsby'

import imgLogoActivity from './../../../assets/images/logoActividad.png'
import imgDecoracionEstrella from './../../../assets/images/decoracionEstrella.png'
import imgPremios from './../../../assets/images/premioEC.gif'
import imgBasePremiosPenis from './../../../assets/images/basePremiosPenis.png'
import imgBasePremiosMenstruacion from './../../../assets/images/basePremiosMenstruacion.png'
import imgBasePremiosZonaV from './../../../assets/images/basePremiosZonaV.png'
import imgInformativa from './../../../assets/images/imgInformativa.png'
import penisMb from './../../../assets/images/penisMb.png'
import menstruacionMb from './../../../assets/images/menstruacionMb.png'
import zonaVMb from './../../../assets/images/zonaVMb.png'

import { LOCALE, numWinners } from '../../../constants/activity-constants'

import './homeContent.scss'
import HomePersonajes from '../../molecules/homePersonajes/homePersonajes'

const HomeContent = props => {
  const { type, onHandleNext, isMobile } = props

  const [typeView, setTypeView] = useState(type)

  const [imgBasePremios, setImgBasePremios] = useState(imgBasePremiosPenis)

  useEffect(() => {
    if (typeView === 'penis') {
      setImgBasePremios(imgBasePremiosPenis)
    } else if (typeView === 'menstruacion') {
      setImgBasePremios(imgBasePremiosMenstruacion)
    } else if (typeView === 'zonaV') {
      setImgBasePremios(imgBasePremiosZonaV)
    }
  }, [typeView])

  return (
    <div className={'f-home ' + (typeView ? 'f-home--' + typeView : '')}>
      <div className="f-home__container">
        <div className="f-home__section1">
          <div className="f-home__section1__up">
            <p>
              <span>Vive divertidas aventuras</span> <br /> con tus personajes
              favoritos en
            </p>
            <figure className="f-home__section1__up__containerImg">
              <img
                className="f-home__section1__up__containerImg__imgLogoActivity"
                src={imgLogoActivity}
                alt="actividad imagen"
              />
              <img
                className="f-home__section1__up__containerImg__imgDecoracionEstrella"
                src={imgDecoracionEstrella}
                alt="actividad imagen"
              />
            </figure>
            <p>
              <span>¿Estás lista para retarte? </span>Elige si quieres jugar con{' '}
              <br />o sin puntos y vuélvete experta en nuestro Mundo Nosotras
            </p>
          </div>
          <div className="f-home__section1__down">
            {!isMobile && (
              <figure className="f-home__section1__down__contentPremios">
                <img
                  className="f-home__section1__down__contentPremios__imgPremios"
                  src={imgPremios}
                  alt="collage de premios"
                />
                <img
                  className="f-home__section1__down__contentPremios__imgBasePremios"
                  src={imgBasePremios}
                  alt="collage de premios"
                />
              </figure>
            )}
            <img
              className="f-home__section1__down__imgInformativa"
              src={imgInformativa}
              alt="texto de explicacion"
              onClick={() => {
                navigate('/juegos')
              }}
            />
            {isMobile && (
              <figure className="f-home__section1__down__contentPersonajesMb">
                <img
                  className="f-home__section1__down__contentPersonajesMb__imgPersonajesMb"
                  src={
                    typeView === 'penis'
                      ? penisMb
                      : typeView === 'menstruacion'
                      ? menstruacionMb
                      : zonaVMb
                  }
                  alt="collage de premios"
                />
                <span
                  className="f-personajes__buttonJugar f-home__section1__down__contentPersonajesMb__buttonJugarMb"
                  onClick={() => {
                    navigate('/juegos')
                  }}
                />
              </figure>
            )}
          </div>
        </div>
        {!isMobile && (
          <div className="f-home__section2">
            <HomePersonajes setTypeView={setTypeView} typeView={typeView} />
          </div>
        )}
      </div>
      <div className="f-home__arrow" onClick={() => onHandleNext()}></div>
    </div>
  )
}

export default HomeContent
